import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    buenaspracticas: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_BUENAS_PRACTICAS = 'GET_ALL_BUENAS_PRACTICAS'
const GET_BUENAS_PRACTICAS_BY_ID = 'GET_BUENAS_PRACTICAS_BY_ID'
const POST_BUENAS_PRACTICAS = 'POST_BUENAS_PRACTICAS'
const UPDATE_BUENAS_PRACTICAS = 'UPDATE_BUENAS_PRACTICAS'
const DELETE_BUENAS_PRACTICAS = 'DELETE_BUENAS_PRACTICAS'
//*******************************************************************************************************************


//MÉTODOS 
export const getAllBuenasPracticas = createAsyncThunk(
    GET_ALL_BUENAS_PRACTICAS,
    async () => {
        try {
            const fullUrl = host + `Fi25BuenasPracticas/obtenerBuenasPracticas`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Vehiculos: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getBuenasPracticasById = createAsyncThunk(
    GET_BUENAS_PRACTICAS_BY_ID,
    async (idBuenasPracticas) => {
        try {
            const fullUrl = host + `Fi25BuenasPracticas/obtenerBuenasPracticasById/${idBuenasPracticas}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertBuenasPracticas = createAsyncThunk(
    POST_BUENAS_PRACTICAS,
    async (data) => {
        try {
            const fullUrl = host + `Fi25BuenasPracticas/agregarBuenasPracticas`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateBuenasPracticas = createAsyncThunk(
    UPDATE_BUENAS_PRACTICAS,
    async (data) => {
        try {
            const fullUrl = host + `Fi25BuenasPracticas/actualizarBuenasPracticas`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const deleteBuenasPracticas = createAsyncThunk(
    DELETE_BUENAS_PRACTICAS,
    async (idBuenasPracticas) => {
        try {
            const fullUrl = host + `Fi25BuenasPracticas/eliminarBuenasPracticas/${idBuenasPracticas}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosBuenasPracticasSlice = createSlice({

    name: 'metodosBuenasPracticasSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllBuenasPracticas.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.buenaspracticas = payload.data.data

        },
        [getBuenasPracticasById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.buenaspracticas = payload.data.data
        },
        [insertBuenasPracticas.fulfilled]: (state, { payload }) => {

        },

        [updateBuenasPracticas.fulfilled]: (state, { payload }) => {

        },
        [deleteBuenasPracticas.fulfilled]: (state, { payload }) => {

        },

    },

})


export const { } = metodosBuenasPracticasSlice.actions
export const BuenasPracticasReducer = metodosBuenasPracticasSlice.reducer